export default {
  displayName: 'News',
  allowableParents: ['Section'],
};
